import { SET_IS_LOADING, SET_GLOBALS, SET_GLOBAL_ERROR, SET_PAGE_DATA, SET_LANGUAGE_DATA, SET_USER, SET_CAN_SCROLL } from './globals.types';

const INITIAL_STATE = {
	settings: {},
	isLoading: false,
	user: null,
	canScroll: true,
	pageData: {
		response: null,
		isLoading: true,
		isError: false,
		languages: [],
		key: Math.random(),
		url: null,
	},
};

const globalsReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case SET_IS_LOADING:
			return {
				...state,
				isLoading: action.payload,
			};

		case SET_CAN_SCROLL:
			console.log('can scroll', action.payload);
			return {
				...state,
				canScroll: action.payload,
			};

		case SET_GLOBAL_ERROR:
			return {
				...state,
				globalError: action.payload.response,
			};

		case SET_GLOBALS:
			return {
				...state,
				settings: action.payload,
			};

		case SET_PAGE_DATA:
			return {
				...state,
				pageData: { ...state.pageData, ...action.payload },
			};

		case SET_LANGUAGE_DATA:
			return {
				...state,
				languages: action.payload,
			};

		case SET_USER:
			return {
				...state,
				user: action.payload,
			};

		default:
			return state;
	}
};

export default globalsReducer;
